import React from 'react'
import './Skills.css'

export default function Skills() {
  return (
    <section>
      <div className="section-title">Skills</div>
      <div className="skills-section">
        <div className="card">
          <div className="label">Languages</div>
          <ul>
            <li className="item">TypeScript</li>
            <li className="item">Python</li>
            <li className="item">Java</li>
            <li className="item">C#</li>
          </ul>
        </div>
        <div className="card">
          <div className="label">Frontend</div>
          <ul>
            <li className="item">React</li>
            <li className="item">Material-UI</li>
            <li className="item">JQuery</li>
            <li className="item">Figma</li>
          </ul>
        </div>
        <div className="card">
          <div className="label">Backend</div>
          <ul>
            <li className="item">Express</li>
            <li className="item">Flask</li>
            <li className="item">REST API</li>
            <li className="item">WebSocket</li>
          </ul>
        </div>
        <div className="card">
          <div className="label">Other</div>
          <ul>
            <li className="item">PyTorch</li>
            <li className="item">AWS</li>
            <li className="item">three.js</li>
            <li className="item">Unity</li>
          </ul>
        </div>
      </div>
    </section>
  )
}
